import React from 'react'
import { Tooltip } from 'react-bootstrap'

const T = ({children, nubbin, popStyle, wrapStyle}) => {

  const sideSwitcher={
    left:'right',
    right:'left'
  }

  return (
    <div className="help-tooltip" style={{...wrapStyle, position:'absolute'}}>
      <div className="help-tooltip-q">?</div>
      <div className="help-tooltip-pop">
        <Tooltip hidden={false} placement={sideSwitcher[nubbin.split('-')[0]]} 
          style={{...popStyle, maxWidth:200, marginTop:4, position:'absolute'}} 
          className="in" id="help">
          {React.Children.count(children) > 0 ?
          React.Children.map(children, (child => 
            React.cloneElement(child)
          ))
        : null}
        </Tooltip>
      </div>
    </div>
  )
}

export default T


// WEBPACK FOOTER //
// ./src/lib/themes/lingk/Tooltip.js